var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0L7 0L7 5L12 5L12 9.5L3.5 9.5L3.5 16H-4.9723e-08L0 0ZM12 4L8 4L8 0L12 4ZM5.5 11L6.5 11C7.4375 11 8.25 11.8125 8.25 12.75C8.25 13.7187 7.4375 14.5 6.5 14.5H6L6 15.5L6 16L5 16L5 15.5L5 14L5 11.5L5 11H5.5ZM6.5 13.5C6.90625 13.5 7.25 13.1875 7.25 12.75C7.25 12.3437 6.90625 12 6.5 12H6L6 13.5H6.5ZM9.5 11H10.5C11.3125 11 12 11.6875 12 12.5L12 14.5C12 15.3437 11.3125 16 10.5 16H9.5H9L9 15.5L9 11.5L9 11H9.5ZM10.5 15C10.75 15 11 14.7812 11 14.5L11 12.5C11 12.25 10.75 12 10.5 12H10L10 15H10.5ZM13 11H13.5H15H15.5L15.5 12H15H14L14 13H15H15.5L15.5 14H15H14L14 15.5L14 16H13L13 15.5L13 13.5L13 11.5L13 11Z",
    fill: "#98BCD6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.c0857a8da63e938ec0d3138163383062.svg";
export { ForwardRef as ReactComponent };